import React from 'react';
import PropTypes from 'prop-types';
import DashboardIndicatorComponent from './DashboardIndicatorComponent';
import { Grid } from '@mui/material';

const DashboardIndicatorsContainer = ({ indicators }) => {
  const getSortedIndicators = indicators => {
    let sortedIndicators = [];
    sortedIndicators = indicators.sort((a, b) => {
      if (a.orderNo > b.orderNo) return 1;
      else return -1;
    });
    return sortedIndicators;
  };

  const sortedIndicators = getSortedIndicators(indicators);

  return sortedIndicators ? (
    <Grid container spacing={2}>
      {sortedIndicators.map((indicator, index) => (
        <DashboardIndicatorComponent key={index} indicator={indicator} />
      ))}
    </Grid>
  ) : null;
};

DashboardIndicatorsContainer.propTypes = {
  indicators: PropTypes.array.isRequired
};

export default DashboardIndicatorsContainer;
